import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const WarningIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          {...props}
          ref={ref}
        >
          <path d="M2 2H18V18H2V2Z" fill="currentColor" />
          <path
            d="M2 2V1.5H1.5V2H2ZM18 2H18.5V1.5H18V2ZM18 18V18.5H18.5V18H18ZM2 18H1.5V18.5H2V18ZM2 2.5H18V1.5H2V2.5ZM17.5 2V18H18.5V2H17.5ZM18 17.5H2V18.5H18V17.5ZM2.5 18V2H1.5V18H2.5Z"
            fill="currentColor"
          />
          <path
            d="M9.5 14.25V14.75H10.5V14.25H9.5ZM9.5 12.25V12.75H10.5V12.25H9.5ZM10.5 14.25V13.75H9.5V14.25H10.5ZM10.5 12.25V5H9.5V12.25H10.5Z"
            fill="var(--text-display)"
          />
        </svg>
      </Icon>
    );
  },
);

WarningIcon.displayName = "WarningIcon";
